export const needsUpgrade = (newAccountImplementationType, smartAccountType) => newAccountImplementationType === 'modular' && smartAccountType === 'simple';
